import React from 'react';
import LayoutInput from 'components/forms/layoutInput';
import {optimizerPlusTitle} from 'helpers/dataHelpers';
import Row from 'components/Row';
import Col from 'components/Col';
import Button from 'components/layout/Button';
import ValidationGroup from 'helpers/validation';
import ReportViewer from 'ReportViewer/layout';
import ReportWrapper from 'components/ReportWrapper';
import {getOptimizerPlusData} from 'api/quickCalcs';
import VolumeCalculator from 'helpers/volumeCalculator';
import FooterButton from 'ui/components/layout/footerButton';
import {Footer} from 'ui/components/layout/index';
import events from 'lib/events';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import DealerApi from 'api/dealer';
import session from 'services/sessionService';

class OptimizerPlus extends React.Component {
  static propTypes = {
    intl: intlShape,
  };

  constructor(props) {
    super(props);

    this.group = new ValidationGroup(this._submit);
  }

  state = {
    branch: {state: 'GA'},
    volume: undefined,
    optimizerPlus: undefined,
    loaded: false,
    dealer: {},
    stage: 0,
  };

  componentWillMount() {
    const {formatMessage} = this.props.intl;

    DealerApi.getDealer(session.getUser().dealerId)
      .then(dealer => this.setState({dealer}))
      .catch(err => {
        console.error(err);
        events.publish('error.user', {message: formatMessage({id: 'general.error.retrieve.data'})});
      });
  }

  reset = () => {
    this.setState({
      volume: undefined,
      optimizerPlus: undefined,
      stage: 0,
    });
  };

  _submit = () => {
    getOptimizerPlusData({optimizerPlus: this.state.optimizerPlus || 0, volume: this.state.volume})
      .then(x => {
        this.setState({data: x, stage: 1});
      });
  };

  print = () => {
    events.publish('print', <ReportWrapper><ReportViewer data={this.state.data.analysisObj} /></ReportWrapper>);
  };

  render() {
    const {optimizerPlus, volume, branch, dealer} = this.state;
    const {formatMessage} = this.props.intl;
    const optPlusLabel = optimizerPlusTitle(branch, {}, formatMessage);

    return <div className='qc-opt-plus'>
      {this.state.stage === 0 ? <p className='qc-opt-plus__instructions'>
        <FormattedMessage id={dealer.country === 'CA' ?
          'quick-calcs.optimizer-plus.instructions.ca' :
          'quick-calcs.optimizer-plus.instructions.us'} />
      </p> : null}
      {this.state.stage === 0 ? <div className='qc-opt-plus__input'>
        <Row>
          <Col md={4}>
            <div key='volume' className='form-group'>
              <label><FormattedMessage id='general.volume' /><span className='error' style={{marginLeft: 2}}>*</span></label>
              <VolumeCalculator
                dataKey='volume'
                volume={volume}
                group={this.group}
                poolType={1}
                beforeFocus={false}
                required
                region={dealer.country}
                title={formatMessage({id: 'system.details.select.calculate'})}
                editMode={true}
                onBlur={({value}) => this.setState({volume: value})} />
            </div>
          </Col>
          <Col md={4}>
            <LayoutInput label={optPlusLabel}
                         dataKey='optimizerPlus'
                         value={optimizerPlus}
                         required
                         ref={r => this.optimizerPlus = r}
                         type='number'
                         min={0}
                         dataChanged={({key, value}) => this.setState({optimizerPlus: value})}
                         group={this.group}
                         validate={val => !val || val >= 0 && val < 100}
                         validateMessage={optimizerPlus < 0 || optimizerPlus >= 100 ?
                           <FormattedMessage id='analysis.validate.optimizer.plus' /> :
                           <FormattedMessage id='quick-calcs.optimizer-plus.tolerance'/>} />
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <div className='pull-right qc-opt-plus__buttons'>
              <Button link onClick={this.reset}><FormattedMessage id='quick-calcs.reset' /></Button>
              <Button primary onClick={this.group.validate}><FormattedMessage id='quick-calcs.calculate' /></Button>
            </div>
          </Col>
        </Row>

      </div> : null}

      {this.state.stage === 1 ? <ReportWrapper><ReportViewer language={this.props.intl.locale}
                                                             data={this.state.data.analysisObj} /></ReportWrapper> : null}
      {this.state.stage === 1 ? <Footer>
        <FooterButton icon={'fa-2x bl bl-print'} label={formatMessage({id: 'general.print'})} onClick={this.print} />
      </Footer> : null}
    </div>;
  }
}

export default injectIntl(OptimizerPlus);
